import { createContext } from "react";

export interface GlobalContextType {
    navToggle: boolean;
    registerStudentPopUp?: boolean | undefined;
}

export const GlobalContext = createContext<GlobalContextType | any>(undefined);
